/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online word counter and character counter. Get live counts of words, characters, sentences, paragraphs, reading time and keyword density as you type.`)
};

const es_wc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de palabras en línea gratuito y contador de caracteres. Obtén conteos en vivo de palabras, caracteres, oraciones, párrafos, tiempo de lectura y densidad de palabras clave mientras escribes.`)
};

const de_wc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Wort- und Zeichenzähler. Erhalten Sie Live-Zählungen von Wörtern, Zeichen, Sätzen, Absätzen, Lesezeit und Schlüsselwortdichte bei der Eingabe.`)
};

const nl_wc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online woordteller en karakterteller. Krijg live aantallen woorden, tekens, zinnen, alinea's, leestijd en trefwoorddichtheid terwijl u typt.`)
};

const fr_wc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de mots et caractères en ligne gratuit. Obtenez en direct le nombre de mots, de caractères, de phrases, de paragraphes, le temps de lecture et la densité des mots-clés en tapant.`)
};

const it_wc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di parole e caratteri gratuito online. Ottieni il conteggio in tempo reale di parole, caratteri, frasi, paragrafi, tempo di lettura e densità di parole chiave mentre digiti.`)
};

const pt_br2_wc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de palavras e caracteres online gratuito. Obtenha contagens ao vivo de palavras, caracteres, frases, parágrafos, tempo de leitura e densidade de palavras-chave enquanto digita.`)
};

const pt_wc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de palavras e caracteres online grátis. Obtenha contagens em direto de palavras, caracteres, frases, parágrafos, tempo de leitura e densidade de palavras-chave conforme escreve.`)
};

const ja_wc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン単語カウンターと文字カウンター。入力中に単語、文字、文、段落、読む時間、キーワード密度をリアルタイムで取得できます。`)
};

const zh_wc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线字数和字符计数器。输入文本即可实时获取字数、字符数、句子数、段落数、阅读时间和关键词密度。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_meta_description", locale)
	if (locale === "en") return en_wc_meta_description(inputs)
	if (locale === "es") return es_wc_meta_description(inputs)
	if (locale === "de") return de_wc_meta_description(inputs)
	if (locale === "nl") return nl_wc_meta_description(inputs)
	if (locale === "fr") return fr_wc_meta_description(inputs)
	if (locale === "it") return it_wc_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_wc_meta_description(inputs)
	if (locale === "pt") return pt_wc_meta_description(inputs)
	if (locale === "ja") return ja_wc_meta_description(inputs)
	return zh_wc_meta_description(inputs)
};